import './../styles/service.css'
import React from 'react';
const DigitalTwin = () => {
    return (
        <div className="service">
            <img src="/assets/service.png" alt="服务能力"/>
            <div className='title'>
                <div className="titleBefore">数字孪生系列</div>
                <div className="titleEnd">DIGITAL TWIN</div>
                <div className="temp"></div>
            </div>

            <div className="content">
                <div className="content-title">
                    方案价值
                </div>
                <div className="content-content">
                    基于B/S架构的：Web前端渲染3D仿真软件，全城自主知识产权、三维可视化、虚实联动、虚拟调试、有限元仿真、运动干涉检查、全能AI数采分析能力。
                </div>
                <div className="content-title">
                    云网优势
                </div>
                <div className="content-content">
                    云网：一直专注“Web3D图形引擎”算法的研发，以及、“数字孪生”、“工业仿真”等三维仿真软件开发。提供全方位的智能化数字工厂、智慧城市信息化的产品提供、技术服务、项目实施，与客户共同成长，只为客户创造实际价值！
                </div>
                <img src='/assets/digitaltwin.png' alt="数字孪生"/>
                <div className="content-end">
                    加入云网合作伙伴，开创新业务，获取技术、资源
                </div>
            </div>
        </div>
    )
}
export default DigitalTwin

